<template>
  <ul class="office-inner" v-iscroll>
    <div class="warp-pre">
      <li v-for="(item, index) in listArr" @click="link(false)">
        <a href="#/index/office-detail">
          <div class="head-warp" :class="{active: item.swite}">办证室{{item.name}}</div>
          <div class="body-warp">
            <span>公证员：<i>{{item.peop}}</i></span>
            <br>
            <span>正在办理：{{item.server}}</span>
          </div>
        </a>
      </li>
    </div>
  </ul>
</template>
<script>
  import { mapActions, mapGetters } from 'vuex'
  export default {
    components: {},
    props: [
      'listArr'
    ],
    data () {
      return {
      }
    },
    computed: {
      ...mapGetters([
      ])
    },
    watch: {
    },
    methods: {
      ...mapActions([
        'AgetBack'
      ]),
      hoverCityOver () {
      },
      hoverCityOut (iner) {
      },
      link (swit) {
        this.AgetBack(swit)
      }
    },
    created () {
      setTimeout(() => {
      }, 1000)
    }
  }
</script>
<style lang="scss" rel="stylesheet/scss">
  @import '../assets/scss/variables';
  @import '../assets/scss/mixins';
  .office-inner {
    width: 100%;
    height: 100%;
    overflow: hidden;
    margin: 0;
    padding: 0;
    list-style: none;
    cursor: pointer;
    .warp-pre {
      width: 100%;
      height: auto;
      @include clearfix;
    }
    h3 {
      color: $white;
    }
    li {
      position: relative;
      width: 100%;
      margin-bottom: 10px;
      color: $white;
      @include clearfix;
      a {
        position: relative;
        width: 100%;
        height: 85px;
        display: block;
        border-radius: 6px;
        overflow: hidden;
        background: rgba($brand-blue, .5);
        @include clearfix;
      }
      .head-warp {
        width: 200px;
        height: 100%;
        float: left;
        text-align: center;
        line-height: 85px;
        color: $white;
        font-size: 20px;
        border-radius: 6px;
        background: rgba($gray-dark, .5);
      }
      .head-warp.active {
        background: $brand-green;
      }
      .body-warp {
        width: calc(100% - 200px);
        height: 100%;
        padding-left: 20px;
        padding-top: 15px;
        font-size: 20px;
        float: left;
        span {
          display: inline-block;
          width: 100%;
          overflow: hidden;
          text-overflow:ellipsis;
          white-space: nowrap;
          color: $white;
        }
        i {
          font-style: normal;
          color: $brand-green;
        }
      }
    }
  }
</style>




// WEBPACK FOOTER //
// office-list.vue?63f0ef0c